module.exports = __webpack_public_path__ + "img/MH.d2724028.png";